export const initialObjectTemplate = {
  naam: "",
  nummer: "",
  telefoonnummer: "",
  bouwjaar: "",
  locatie: { adres: "", huisnummer: "", postcode: "", plaats: "" },
  contactpersoon: { naam: "", telefoon: "", email: "" },
  media: { mediaid: "", naam: "", url: "", website: "" },
};

export const makeNewObject = (defaults = {}) => ({
  ...initialObjectTemplate,
  klantid: defaults.klantid || "",
  nummer: defaults.nummer ?? "",
  locatie: { ...initialObjectTemplate.locatie, ...(defaults.locatie || {}) },
  contactpersoon: {
    ...initialObjectTemplate.contactpersoon,
    ...(defaults.contactpersoon || {}),
  },
});

export const getNextObjectNumber = (objecten = []) => {
  const numbers = objecten
    .map((o) => parseInt(o?.nummer, 10))
    .filter((n) => Number.isFinite(n) && n > 0);
  return numbers.length === 0 ? 1 : Math.max(...numbers) + 1;
};

// Object lives only on the client (not yet persisted) when it has no objectid
export const isTempObject = (o) => !o?.objectid;
